import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useWhatsAppSettings } from '../../hooks/useWhatsAppSettings';

export default function FloatingWhatsApp() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin') || location.pathname.startsWith('/tutor');

  if (isDashboard) return null;

  const { whatsappNumber } = useWhatsAppSettings();

  const whatsappMessage = encodeURIComponent("Hello!");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div className="fixed bottom-6 left-6 z-[100] flex flex-col items-start font-sans">

      {/* Popover */}
      <div
        className={`bg-white w-80 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.15)] mb-4 overflow-hidden transition-all duration-300 origin-bottom-left ${isOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-4 pointer-events-none'}`}
      >
        {/* Header */}
        <div className="bg-[#25D366] px-5 py-4 flex items-center gap-3 relative">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <i className="ri-whatsapp-fill text-white text-2xl"></i>
            <span className="absolute bottom-4 right-4 w-2.5 h-2.5 bg-green-400 border-2 border-[#25D366] rounded-full"></span>
          </div>
          <div>
            <h3 className="text-white font-bold text-[15px] leading-tight">GCSE Computing</h3>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        {/* Chat Body (WhatsApp Background) */}
        <div className="p-5 bg-[#efeae2] relative min-h-[140px]">
          {/* Subtle bg pattern for whatsapp look (optional) */}
          <div className="absolute inset-0 opacity-[0.06] bg-[url('https://transparenttextures.com/patterns/cubes.png')] pointer-events-none"></div>

          <div className="relative bg-white text-slate-700 text-[14px] leading-relaxed p-3.5 rounded-2xl shadow-sm rounded-tl-sm mt-2 font-medium">
            👋 Hi there! Need help finding the right Computer Science resources or have a question about our platform? Let us know!
            <p className="text-[10px] text-slate-400 text-right mt-1.5">{new Intl.DateTimeFormat('en-GB', { hour: 'numeric', minute: 'numeric', hour12: true }).format(new Date())}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 bg-white border-t border-slate-100">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-[#25D366] hover:bg-[#1DA851] text-white font-bold py-3 rounded-xl transition-colors flex items-center justify-center gap-2 shadow-sm text-sm"
          >
            <i className="ri-whatsapp-fill text-lg"></i>
            Start Chat on WhatsApp
          </a>
        </div>
      </div>

      {/* Floating Trigger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full shadow-[0_4px_15px_rgba(37,211,102,0.4)] transition-all duration-300 flex items-center justify-center cursor-pointer hover:-translate-y-1 group relative z-10"
        aria-label="Toggle WhatsApp Chat"
      >
        <div className="relative w-full h-full flex items-center justify-center">
          <i className={`ri-whatsapp-line text-3xl transition-transform duration-300 absolute ${isOpen ? 'scale-0 rotate-90 opacity-0' : 'scale-100 rotate-0 opacity-100'}`}></i>
          <i className={`ri-close-line text-3xl transition-transform duration-300 absolute ${!isOpen ? 'scale-0 -rotate-90 opacity-0' : 'scale-100 rotate-0 opacity-100'}`}></i>
        </div>

        {!isOpen && (
          <>
            {/* Pulse effect rings */}
            <span className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-75"></span>

            {/* Tooltip */}
            <div className="absolute left-16 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-xs font-semibold px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
              Chat with us!
              <div className="absolute top-1/2 -left-2 -translate-y-1/2 border-4 border-transparent border-r-slate-900"></div>
            </div>
          </>
        )}
      </button>

    </div>
  );
}
